import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'index',
        'less',
        `
.layout-console {
  height: 100vh;

  #components-layout-demo-top-side-2 .logo {
    float: left;
    width: 120px;
    height: 31px;
    margin: 16px 24px 16px 0;
    background: rgba(255, 255, 255, 0.3);
  }

  .ant-row-rtl #components-layout-demo-top-side-2 .logo {
    float: right;
    margin: 16px 0 16px 24px;
  }

  .site-layout-background {
    background: #fff;
  }

  .header {
    background: #fff;
    font-size: 18px;
    padding: 0 0 0 10px;
    margin-bottom: 3px;
    line-height: 54px;
    height: 54px;
  }

  .logo {
    height: 32px;
    margin: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 32px;
    }
    span {
      width: 100px;
      height: 30px;
      overflow: hidden;
      margin-left: 12px;
      font-size: 16px;
      color: #000000d9;
      font-weight: 700;
      vertical-align: text-bottom;
      text-transform: uppercase;
      display: inline-block;
    }
  }
}
    `,
    );

    return [['src', 'layouts', 'BasicLayout'], file];
}
